import React, { FC, useEffect, useLayoutEffect, useRef, useState } from 'react'
import 'bpmn-js/dist/assets/diagram-js.css'
import 'bpmn-js/dist/assets/bpmn-js.css'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css'
import '@bpmn-io/properties-panel/assets/properties-panel.css'

//@ts-ignore
import DmnModeler from 'dmn-js/lib/Modeler'
import {
  DmnPropertiesPanelModule,
  DmnPropertiesProviderModule,
  //@ts-ignore
} from 'dmn-js-properties-panel'

import 'dmn-js/dist/assets/dmn-font/css/dmn-embedded.css'
import 'dmn-js/dist/assets/dmn-js-decision-table-controls.css'
import 'dmn-js/dist/assets/dmn-js-decision-table.css'
import 'dmn-js/dist/assets/dmn-js-drd.css'
import 'dmn-js/dist/assets/dmn-js-literal-expression.css'
import 'dmn-js/dist/assets/dmn-js-shared.css'
import { Button, DeleteModal } from '@sistemiv/s-components'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import EditableInput from './EditableInput'
import { CheckIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline'
import FilesAndDirectoriesService from '../../services/FilesAndDirectoriesService'
import { useDirectoryContent } from '../../repositories/directory/directoryContent.repository'
import { useProjectContent } from '../../repositories/project/projectContent.repository'
import Breadcrumbs from '../layout/Breadcrumbs'
import { useRenameItem } from '../../repositories/project-item/mutations/item-rename'

const DEFAULT_XML = `<?xml version="1.0" encoding="UTF-8"?>
<definitions xmlns="https://www.omg.org/spec/DMN/20191111/MODEL/" xmlns:dmndi="https://www.omg.org/spec/DMN/20191111/DMNDI/" xmlns:dc="http://www.omg.org/spec/DMN/20180521/DC/" id="Definitions_1lmea3i" name="Definitions" namespace="http://camunda.org/schema/1.0/dmn">
  <decision id="Decision_0mqgtic" name="Decision 1">
    <decisionTable id="DecisionTable_11azyal">
      <input id="Input_1">
        <inputExpression id="InputExpression_1" typeRef="string">
          <text></text>
        </inputExpression>
      </input>
      <output id="Output_1" typeRef="string" />
    </decisionTable>
  </decision>
  <dmndi:DMNDI>
    <dmndi:DMNDiagram>
      <dmndi:DMNShape dmnElementRef="Decision_0mqgtic">
        <dc:Bounds height="80" width="180" x="160" y="100" />
      </dmndi:DMNShape>
    </dmndi:DMNDiagram>
  </dmndi:DMNDI>
</definitions>`

//const LOCAL_STORAGE_KEY = 'dmnAutosave'

type Props = {
  file: string
  directoryPath: string
  //onSave: (xml: any) => void
}

const ModelerDmn: FC<Props> = ({ file, directoryPath }) => {
  const link = useRef<HTMLAnchorElement | null>(null)
  // const fileInputRef = useRef<HTMLInputElement>(null)
  const modelerRef = useRef<DmnModeler | null>(null)
  const { org, project } = useParams()
  // const autosaveTimeout = useRef<NodeJS.Timeout | null>(null)
  const { t } = useTranslation()
  const [fileName, setFileName] = useState(file && file !== 'new' ? file : 'New DMN diagram.dmn')
  const [saved, setSaved] = useState(false)
  const [failed, setFailed] = useState(false)
  const { data: folderFiles } = useDirectoryContent(directoryPath)
  const { data: projectFiles } = useProjectContent()
  const [openWarningModal, setOpenWarningModal] = useState(false)
  // const [inputFocused, setInputFocused] = useState(false)
  const [saveLoading, setSaveloading] = useState(false)

  // const hasBeenSaved = useRef<boolean>(!!(file && file !== 'new'))

  const { mutate: renameItem } = useRenameItem(directoryPath)

  // const handleRename = (newName: string) => {
  //   if (!hasBeenSaved.current) {
  //     setFileName(newName)
  //     return
  //   }
  //   if (newName === fileName) return
  //   renameItem(
  //     {
  //       organization: org!,
  //       path: `${project}/${directoryPath ? `${directoryPath}/` : ''}${fileName}`,
  //       newName,
  //       type: 'files',
  //     },
  //     {
  //       onSuccess: () => setFileName(newName),
  //       onError: () => {
  //         setFailed(true)
  //         setTimeout(() => {
  //           setFailed(false)
  //         }, 1000)
  //       },
  //     },
  //   )
  // }

  useEffect(() => {
    if (modelerRef.current) return

    modelerRef.current = new DmnModeler({
      drd: {
        propertiesPanel: {
          parent: '#properties',
        },
        additionalModules: [DmnPropertiesPanelModule, DmnPropertiesProviderModule],
      },
      container: '#canvas',
    })

    const loadDiagram = async () => {
      try {
        // const savedXml = localStorage.getItem(LOCAL_STORAGE_KEY)
        const xml = DEFAULT_XML
        const { warnings } = await modelerRef.current!.importXML(xml)
        if (warnings.length) console.warn('Import warnings:', warnings)
        const activeEditor = modelerRef.current!.getActiveViewer()
        activeEditor.get('canvas').zoom('fit-viewport')

        //setupAutosave()
      } catch (err) {
        console.error('Error importing DMN diagram', err)
      }
    }

    loadDiagram()
  }, [])

  useEffect(() => {
    const fetchAndLoadDiagram = async () => {
      try {
        const response = await FilesAndDirectoriesService.download(
          org!,
          `${project}/${directoryPath ? `${directoryPath}/${file}` : `${file}`}`,
          'files',
        )
        const contentType = response.headers['content-type']
        // Proveri da li je uspešno vraćen Blob
        // if (response.ok) {
        const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: contentType })
        const text = await blob.text() // Pretvoriš Blob u tekst (XML)

        // Učitaj BPMN XML u modeler
        await modelerRef.current?.importXML(text)
        // }
      } catch (error) {
        console.error('Greška pri učitavanju  dijagrama:', error)
      }
    }

    if (file && file !== 'new' && modelerRef.current) {
      fetchAndLoadDiagram()
    }
  }, [file, org, directoryPath, project])

  // Autosave funkcionalnost - čuva u localStorage
  // const setupAutosave = () => {
  //   const activeEditor = modelerRef.current?.getActiveViewer()
  //   if (!activeEditor) return

  //   const eventBus = activeEditor.get('eventBus')
  //   eventBus.on('commandStack.changed', async () => {
  //     if (autosaveTimeout.current) clearTimeout(autosaveTimeout.current)

  //     autosaveTimeout.current = setTimeout(async () => {
  //       if (!modelerRef.current) return
  //       const { xml } = await modelerRef.current.saveXML({ format: true })
  //       localStorage.setItem(LOCAL_STORAGE_KEY, xml)
  //     }, 1000) // Autosave posle 1 sekunde
  //   })
  // }

  // Undo i Redo funkcije
  const handleUndo = () => {
    const activeEditor = modelerRef.current?.getActiveViewer()
    const commandStack = activeEditor?.get('commandStack')
    commandStack?.undo()
  }

  const handleRedo = () => {
    const activeEditor = modelerRef.current?.getActiveViewer()
    const commandStack = activeEditor?.get('commandStack')
    commandStack?.redo()
  }

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'z') {
        event.preventDefault()
        handleUndo()
      }
      if ((event.ctrlKey && event.key === 'y') || (event.ctrlKey && event.shiftKey && event.key === 'z')) {
        event.preventDefault()
        handleRedo()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  useLayoutEffect(() => {
    return () => {
      modelerRef.current?.destroy()
    }
  }, [])

  const handleExport = async () => {
    if (!modelerRef.current) return
    const { xml } = await modelerRef.current.saveXML({ format: true })
    if (link.current) {
      const encodedData = encodeURIComponent(xml)
      link.current.setAttribute('href', 'data:application/bpmn20-xml;charset=UTF-8,' + encodedData)
      link.current.setAttribute('download', `${fileName}${!fileName.includes('.dmn') ? '.dmn' : ''}`)
    }
  }

  // const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0]
  //   if (!file || !modelerRef.current) return

  //   try {
  //     const fileContent = await file.text()
  //     await modelerRef.current.importXML(fileContent)
  //     localStorage.setItem(LOCAL_STORAGE_KEY, fileContent) // Sačuvaj učitani fajl u localStorage
  //     setupAutosave()
  //   } catch (error) {
  //     console.error('Error importing XML:', error)
  //     alert('Invalid DMN file. Please upload a valid DMN file.')
  //   }
  // }

  const onSave = async () => {
    if (!modelerRef.current) return
    setSaveloading(true)
    try {
      const { xml } = await modelerRef.current.saveXML({ format: true })
      const blob = new Blob([xml!], { type: 'text/xml' })
      const file = new File([blob], `${fileName}${!fileName.includes('.dmn') ? '.dmn' : ''}`, { type: 'text/xml' })

      await FilesAndDirectoriesService.saveFile(
        org!,
        `${project}/${
          directoryPath
            ? `${directoryPath}/${fileName}${!fileName.includes('.dmn') ? '.dmn' : ''}`
            : `${fileName}${!fileName.includes('.dmn') ? '.dmn' : ''}`
        }`,
        file,
      )
      //alert('File saved successfully!')
      setSaved(true)
      // hasBeenSaved.current = true
      setTimeout(() => {
        setSaved(false)
      }, 1000)
    } catch (error) {
      console.error('Error saving file:', error)
      // alert('Failed to save file.')
      setFailed(true)
      setTimeout(() => {
        setFailed(false)
      }, 1000)
    } finally {
      setSaveloading(false)
      if (openWarningModal) setOpenWarningModal(false)
    }
  }

  const handleRename = (newName: string) => {
    return new Promise<void>((resolve, reject) => {
      renameItem(
        {
          organization: org!,
          path: `${project}/${directoryPath ? `${directoryPath}/` : ''}${file}`,
          newName,
          type: 'files',
        },
        {
          onSuccess: () => {
            setFileName(newName)
            resolve()
          },
          onError: () => {
            setFailed(true)
            setTimeout(() => setFailed(false), 1000)
            reject()
          },
        },
      )
    })
  }

  const handleSave = async () => {
    if (!modelerRef.current) return
    const files = directoryPath ? folderFiles : projectFiles

    const fileExists = files.contents.find((file) =>
      fileName.includes('.') ? file.name === fileName : file.name.slice(0, file.name.lastIndexOf('.')) === fileName,
    )

    if (file === 'new' && fileExists) {
      setOpenWarningModal(true)
    } else {
      try {
        if (file && file !== 'new' && file !== fileName) {
          await handleRename(fileName)
        }
        await onSave()
      } catch (err) {
        console.error('Rename or save failed:', err)
      }
    }
  }

  // const handleSave = async () => {
  //   if (!modelerRef.current) return
  //   const files = directoryPath ? folderFiles : projectFiles
  //   if (
  //     (file === 'new' || fileName !== file) &&
  //     files.contents.find((file) =>
  //       fileName.includes('.') ? file.name === fileName : file.name.slice(0, file.name.lastIndexOf('.')) === fileName,
  //     )
  //   ) {
  //     setOpenWarningModal(true)
  //   } else onSave()
  // }

  return (
    <div className='w-full h-full flex flex-col'>
      <div className='w-full h-16 flex justify-between border-b border-gray-300 items-center px-8'>
        <Breadcrumbs>
          {/* <EditableInput value={fileName} onRename={handleRename} setInputFocused={setInputFocused} /> */}
          <EditableInput value={fileName} onChange={setFileName} />
        </Breadcrumbs>
        <div className='flex gap-x-4'>
          {failed && (
            <div className='flex items-center justify-center text-red-600 transition-opacity duration-500 ease-in-out opacity-100'>
              <ExclamationCircleIcon className='text-red-600 w-6 h-6 mr-2' /> <span>Failed to save</span>
            </div>
          )}
          {saved && !failed ? (
            <div className='flex items-center justify-center text-[#4B526C] transition-opacity duration-500 ease-in-out opacity-100'>
              <CheckIcon className='text-[#4B526C] w-6 h-6 mr-2' /> <span>Saved</span>
            </div>
          ) : (
            <Button
              className='border border-blue-500 text-blue-500 bg-white px-4 !py-1 rounded-md hover:bg-sky-100  transition-opacity duration-500 ease-in-out opacity-100 disabled:opacity-50 disabled:cursor-not-allowed'
              onClick={handleSave}
              // disabled={inputFocused}
            >
              {t('save')}
            </Button>
          )}
          <a id='js-download-diagram' download='MyExampleDoc' target='_blank' ref={link} onClick={handleExport}>
            <button
              id='js-download-diagram'
              className='border border-blue-500 text-blue-500 !text-sm bg-white px-4 !py-1 rounded-md hover:bg-sky-100 transition-colors duration-300'
            >
              {t('download')}
            </button>
          </a>
        </div>
      </div>
      <div className='w-full h-full flex'>
        <div id='canvas' className='w-4/5'></div>
        <div id='properties' className='w-1/4 border-l border-solid border-slate-300'></div>
      </div>
      <div className='h-16 py-4 px-8 border border-solid border-slate-300 flex items-center justify-between space-x-5'>
        <div className='flex items-center px-8 gap-x-5'>
          <Button
            onClick={handleUndo}
            className='border border-gray-500 text-gray-500 bg-white px-4 py-1 rounded hover:bg-gray-100'
          >
            Undo
          </Button>
          <Button
            onClick={handleRedo}
            className='border border-gray-500 text-gray-500 bg-white px-4 py-1 rounded hover:bg-gray-100'
          >
            Redo
          </Button>
        </div>
        <div className='flex items-center px-8 gap-x-5'></div>
      </div>
      {openWarningModal && (
        <DeleteModal
          title={t('warning')}
          description={t('saveFileWarningMsg')}
          open={openWarningModal}
          setOpen={setOpenWarningModal}
          onDeleteConfirmed={onSave}
          actionLabel={t('continue')}
          isLoading={saveLoading}
        />
      )}
    </div>
  )
}

export default ModelerDmn
